import { render, staticRenderFns } from "./important-work.vue?vue&type=template&id=4b8337d6&scoped=true"
import script from "./important-work.vue?vue&type=script&lang=js"
export * from "./important-work.vue?vue&type=script&lang=js"
import style0 from "./important-work.vue?vue&type=style&index=0&id=4b8337d6&prod&scoped=true&lang=css"
import style1 from "./important-work.vue?vue&type=style&index=1&id=4b8337d6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b8337d6",
  null
  
)

export default component.exports